import React, { useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Step,
  StepLabel,
  Stepper,
  ButtonGroup,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import { useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import PersonalInformation from "./components/PersonalInformation";
import EmployeeInformation from "./components/EmployeeInformation";
import PFDetails from "./components/PFDetails/index";
import BankDetails from "./components/BankDetails";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
import TaxDetails from "./components/TaxDetails";
import { resourceOptions, steps, typedata } from "./employeeData";
const AddEmployee = () => {
  const navigate = useNavigate();
  const [Mobilecode, setMobilecode] = useState("");
  const { validationMessages, setValidationMessages, AccessData, EmpSubmit } =
    useUserDetails();

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [activeStep, setActiveStep] = useState(0); //Used to store current step

  const { circleLoading, setCirleLoading } = useLoading();
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [resources] = useState(resourceOptions);

  const probationOptions = [...Array(12)].map((_, index) => {
    const month = index + 1;
    return {
      value: `${month} Month${month > 1 ? "s" : ""}`,
      label: `${month} Month${month > 1 ? "s" : ""}`,
    };
  });

  const [reportManager, setReportManager] = useState([]);
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [shiftdata, setshiftdata] = useState([]);
  const [id, setid] = useState("");
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [allfecthdata, setallfecthdata] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    //personal information
    salutation: null,
    activeuser: false,
    firstName: "",
    lastName: "",
    fathername: "",
    userName: "",
    dob: "yyyy-mm-dd",
    gender: null,
    martialstatus: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",

    countryCode: null,
    contactNumber: "",
    emergencyNumber: "",
    email: "",
    aadharnumber: "",
    pannumber: "",
    lastworking: "",
    role: "",
    //employee information
    employeeId: "",
    joiningDate: "yyyy-mm-dd",
    grade: "",
    reportingManager: null,
    employeeType: null,
    department: null,
    isActive: false,
    LastWorkingDay: null,
    designation: null,
    officialmailid: "",
    shifts: "",
    previousExperience: "",
    attendanceId: "",

    //tax details
    taxRegime: "",

    // probationPeriod: probationOptions[2],
    probationPeriod: false,
    user: false,
    //bank information
    accountnumber: "",
    bankname: "",
    enterIfsc: "",
    cifnumber: "",
    branchname: "",
    isIfscVerify: "",

    //PF & ESI Details
    uannumber: "",
    memberid: "",
    esicnumber: "",

    //personal information status
    salutationStatus: "unchecked",
    firstNameStatus: "unchecked",
    lastNameStatus: "unchecked",
    fathernameStatus: "unchecked",
    userNameStatus: "unchecked",
    dobStatus: "unchecked",
    genderStatus: "unchecked",
    martialstatus: "unchecked",
    addressStatus: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    stateStatus: "unchecked",
    roleStatus: "unchecked",
    zipcodeStatus: "unchecked",
    countryCodeStatus: "unchecked",
    contactNumberStatus: "unchecked",
    emergencyNumberStatus: "unchecked",
    emailStatus: "unchecked",
    officialmailidStatus: "unchecked",
    shiftsStatus: "unchecked",
    aadharnumberStatus: "unchecked",
    pannumberStatus: "unchecked",

    //employee information status
    employeeIdStatus: "unchecked",
    joiningDateStatus: "unchecked",
    gradeStatus: "unchecked",
    reportingManagerStatus: "unchecked",
    employeeTypeStatus: "unchecked",
    departmentStatus: "unchecked",
    designationStatus: "unchecked",
    previousExperienceStatus: "unchecked",
    attendanceIdStatus: "unchecked",

    //bank information status
    enterIfscStatus: "unchecked",
    accountnumberStatus: "unchecked",
    banknameStatus: "unchecked",
    cifnumberStatus: "unchecked",
    branchnameStatus: "unchecked",

    //tax information status
    taxRegimeStatus: "unchecked",

    //pf & esic information Status
    uannumberStatus: "",
    memberidStatus: "",
    esicnumberStatus: "",
  });
  const [originalWeekoffData, setOriginalWeekoffData] = useState({
    salutation: null,
    firstName: "",
    lastName: "",
    fathername: "",
    userName: "",
    dob: "yyyy-mm-dd",
    gender: null,
    martialstatus: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    countryCode: null,
    contactNumber: "",
    emergencyNumber: "",
    email: "",
    aadharnumber: "",
    pannumber: "",

    //employee information
    employeeId: "",
    joiningDate: "yyyy-mm-dd",
    grade: "",
    reportingManager: null,
    employeeType: null,
    department: null,
    designation: null,
    officialmailid: "",
    shifts: "",
    previousExperience: "",
    // probationPeriod: probationOptions[2],
    // user: null,
    probationPeriod: false,
    user: false,
    //bank information
    accountnumber: "",
    bankname: "",
    enterIfsc: "",
    cifnumber: "",
    branchname: "",
    isIfscVerify: "",

    //PF & ESI Details
    uannumber: "",
    memberid: "",
    esicnumber: "",
  });
  const [roledata, setroledata] = useState([]);

  useEffect(() => {
    onDepartmentDropdown();
    onDesignationDropdown();
    onReportingManagerDropdown();
    setValidationMessages("");
    getshiftsdata();
    getroles();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    if (id) {
      setid(id);
      getemployeedata(id);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getemployeedata(id);
    }
  }, [department, designation, reportManager]);

  const getshiftsdata = async () => {
    const query = `
             query { 
  allShifts { 
    data { 
      id 
      name 
      startTime 
      endTime 
      totalWorkingHours 
    } 
    success 
    message 
    error 
  } 
} 
              `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      let val = response.data?.data?.allShifts.data;

      setshiftdata(val);
      // setCirleLoading(false)
    } catch (error) {
      console.error("ResponseError:", error);
      // setCirleLoading(false)
    }
  };

  const getroles = async () => {
    // setCirleLoading(true)
    const query = `query{
   allRoles{
     data{
       id
       role
       description
     }
   }
 }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // setCirleLoading(false)
      const wfhList = response.data.data.allRoles[0]?.data;

      setroledata(wfhList);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onDepartmentDropdown = async () => {
    // setCirleLoading(true)
    const query = `query {
                        allDepartment {
                        id
                        departmentName
                        departmentCode
                        }
                    }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Extract department data from the response
      const departmentListdata = response.data.data.allDepartment;
      // setCirleLoading(false)
      setDepartment(departmentListdata);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      // setCirleLoading(false)
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const onDesignationDropdown = async () => {
    // setCirleLoading(true)
    const query = ` query{
                            allDesignation{
                                id
                                departmentName
                                designation
                                lastUpdate
                            }
                        }`;

    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // setCirleLoading(false)
      // Extract designation data from the response
      const designationListdata = response.data.data.allDesignation;
      setDesignation(designationListdata);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      // setCirleLoading(false)
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };
  const onReportingManagerDropdown = async () => {
    const query = `query {
            allManagers {
              id
              user {
                id
                firstName
                lastName
                empid
              }
            }
          }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Extract reportingManager data from the response
      const reportingManagerListdata = response.data.data.allManagers;

      setReportManager(reportingManagerListdata);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseErrorsss:", error.message);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const handleEmployeeDataChange = (event, selectEvent) => {
    let employeeState = { ...employeeData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "role") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "taxRegime") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "gender") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          gender: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "martialstatus") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          maritalStatus: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "country") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          country: "",
        });
        setValidationMessages({
          ...validationMessages,
          city: "Select the City",
          state: "Select the State",
        });

        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "state") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          state: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "city") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          city: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "shifts") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          shifts: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "countryCode") {
        const lengthRegex = new RegExp("^[A-Za-z0-9\\W]");
        setValidationMessages({
          ...validationMessages,
          countryCode: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "reportingManager") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");

        if (id) {
          let fil = allfecthdata.filter((val) => val.id == id);

          if (fil[0]?.id == event?.id) {
            setValidationMessages({
              ...validationMessages,
              reportingManager: "You selected the same user with the same ID.",
            });
          } else {
            setValidationMessages({
              ...validationMessages,
              reportingManager: "",
            });
          }
        } else {
          setValidationMessages({
            ...validationMessages,
            reportingManager: "",
          });
        }

        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "employeeType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          employeeType: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "department") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          department: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "designation") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          designation: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      employeeState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            setValidationMessages({
              ...validationMessages,
              firstName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");
            setValidationMessages({
              ...validationMessages,
              lastName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "fathername":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,40})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "userName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case 'userName': {
        //     const alphaNumberLengthRegex = new RegExp('^([A-Za-z0-9 ]{1,20})$');

        //     if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
        //         employeeState[event.target.name + 'Status'] = 'success';
        //     } else {
        //         employeeState[event.target.name + 'Status'] = event.target.value === '' ? 'unchecked' : 'error';
        //     }
        // } break;
        case "dob":
          {
            const enteredDate = new Date(event.target.value);
            const today = new Date();
            const date18YearsAgo = new Date(
              today.getFullYear() - 18,
              today.getMonth(),
              today.getDate(),
            );

            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$",
            );
            setValidationMessages({
              ...validationMessages,
              dob: "",
            });
            if (enteredDate <= date18YearsAgo) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address":
          {
            // const alphaNumberLengthRegex = new RegExp(
            //   "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,250}$"
            // );
            const alphaNumberLengthRegex = new RegExp("^.{1,250}$", "s");
            setValidationMessages({
              ...validationMessages,
              address: "",
            });
            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emergencyNumber":
          {
            const phoneRegex = new RegExp("^[0-9]{10}$");

            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactNumber":
          {
            const phoneRegex = new RegExp("^[0-9]{10}$");
            setValidationMessages({
              ...validationMessages,
              contactNumber: "",
            });
            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipcode":
          {
            const zipcodeRegex = new RegExp("^[a-zA-Z0-9]{5,8}$");
            setValidationMessages({
              ...validationMessages,
              zipcode: "",
            });
            if (zipcodeRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "email":
          {
            const emailRegex = /^[\w.-]+@([\w-]+\.)+[a-zA-Z]{3}$/;

            setValidationMessages({
              ...validationMessages,
              email: "",
            });
            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "officialmailid":
          {
            const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
            setValidationMessages({
              ...validationMessages,
              officialmailid: "",
            });
            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "aadharnumber":
          {
            // Remove all non-digit characters and limit to 12 digits
            const sanitizedValue = event.target.value
              .replace(/\D/g, "")
              .slice(0, 12);

            // Add spaces after every 4 digits for formatting
            const formattedValue = sanitizedValue
              .replace(/(\d{4})(\d+)/, "$1 $2")
              .replace(/(\d{4} \d{4})(\d+)/, "$1 $2");

            // Regex to validate strict format XXXX XXXX XXXX
            const aadharRegex = new RegExp("^\\d{4} \\d{4} \\d{4}$");

            // Update the value in the event target
            event.target.value = formattedValue;

            // Update the validation messages and employeeState
            setValidationMessages({
              ...validationMessages,
              aadharNumber: "",
            });

            employeeState[event.target.name + "Status"] = aadharRegex.test(
              formattedValue,
            )
              ? "success"
              : formattedValue === ""
                ? "unchecked"
                : "error";
          }
          break;

        case "pannumber":
          {
            // Regex to validate PAN format (5 letters, 4 digits, and 1 letter)
            const panRegex = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$", "i");
            setValidationMessages({
              ...validationMessages,
              panNumber: "",
            });
            if (panRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "employeeId":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{3,15})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "previousExperience":
          {
            // Regex to match up to 2 digits before and after a decimal point (e.g., "12", "12.34", "0.5")
            const alphaNumberLengthRegex = /^\d{0,2}(\.[0-9])?$/;

            if (alphaNumberLengthRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "attendanceId":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,15}$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "joiningDate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$",
            );
            setValidationMessages({
              ...validationMessages,
              joiningDate: "",
            });
            if (dateLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastworking":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$",
            );
            // setValidationMessages({
            //   ...validationMessages,
            //   joiningDate: "",
            // });
            if (dateLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case "user":
        //   {
        //     const userRegex = new RegExp("^[a-zA-Z0-9 ]{1,20}$"); // Allows alphanumeric characters and spaces, 1-20 chars
        //     setValidationMessages({
        //       ...validationMessages,
        //       user: "",
        //     });

        //     if (userRegex.test(event.target.value)) {
        //       employeeState[event.target.name + "Status"] = "success";
        //     } else {
        //       employeeState[event.target.name + "Status"] =
        //         event.target.value === "" ? "unchecked" : "error";
        //     }
        //   }
        //   break;
        case "probationPeriod":
          {
            const userRegex = new RegExp("^[a-zA-Z0-9 ]{1,20}$"); // Allows alphanumeric characters and spaces, 1-20 chars
            setValidationMessages({
              ...validationMessages,
              user: "",
            });

            if (userRegex.test(event.target.value)) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "grade":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "enterIfsc":
          {
            const ifscRegex = new RegExp("^[A-Z]{4}0[A-Z0-9]{6}$");
            setValidationMessages({
              ...validationMessages,
              enterIfsc: "",
            });
            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "accountnumber":
          {
            const ifscRegex = new RegExp("^[0-9]{1,25}$");
            setValidationMessages({
              ...validationMessages,
              accountnumber: "",
            });

            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "bankname":
          {
            const ifscRegex = new RegExp("^[A-Za-z ]{1,25}$");
            setValidationMessages({
              ...validationMessages,
              bankname: "",
            });

            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "branchname":
          {
            const ifscRegex = new RegExp("^[A-Za-z]{1,20}$");
            setValidationMessages({
              ...validationMessages,
              branchname: "",
            });
            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "cifnumber":
          {
            const cifRegex = new RegExp("^[0-9]{1,25}$");
            setValidationMessages({
              ...validationMessages,
              cifnumber: "",
            });

            if (cifRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "uannumber":
          {
            // Regex to validate a 12-digit UAN number
            const uanRegex = new RegExp("^[0-9]{12}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "memberid":
          {
            // Regex to validate a 12-digit UAN number
            const uanRegex = new RegExp("^[A-Za-z0-9]{1,25}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "esicnumber":
          {
            // Regex to validate a 12-digit UAN number
            const uanRegex = new RegExp("^[A-Za-z0-9]{1,25}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        employeeState[event.target.name] = event.target.value;
      }
    }
    setEmployeeData(employeeState);
  };

  // const handleEmployee = (value, fieldName,phonecode) => {
  //   console.log('phonecode:',phonecode);

  //   // Validate emergencyNumber specifically
  //   if (fieldName === "emergencyNumber") {
  //     const isValid = /^[0-9]{12}$/.test(value); // Check if it's a 10-digit number
  //     setEmployeeData((prevData) => ({
  //       ...prevData,
  //       [fieldName]: value,
  //       emergencyNumberStatus:  value > phonecode  ? "success" : "error",
  //     }));
  //   } else if (fieldName === "contactNumber") {
  //     const isValid = /^[0-9]{12}$/.test(value); // Check if it's a 10-digit number
  //     setEmployeeData((prevData) => ({
  //       ...prevData,
  //       [fieldName]: value,
  //       contactNumberStatus:  value > phonecode  ? "success" : "error",
  //     }));
  //   } else {
  //     // General handler for other fields
  //     setEmployeeData((prevData) => ({
  //       ...prevData,
  //       [fieldName]: value,
  //     }));
  //   }
  // };
  const handleEmployee = (value, fieldName, phonecode) => {
    if (fieldName === "emergencyNumber" || fieldName === "contactNumber") {
      setMobilecode(phonecode);
      if (value?.length <= phonecode?.length) {
        // If only the country code is present, remove error and set status to "unchecked"
        setEmployeeData((prevData) => ({
          ...prevData,
          [fieldName]: value,
          [`${fieldName}Status`]: "unchecked",
        }));
      } else {
        const mobileNumber = value.substring(phonecode?.length);

        const isValid = /^[0-9]{10}$/.test(mobileNumber);

        setEmployeeData((prevData) => ({
          ...prevData,
          [fieldName]: value,
          [`${fieldName}Status`]: value > phonecode ? "success" : "success",
        }));
      }
    } else {
      // General handler for other fields
      setEmployeeData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
    }
  };

  const handleBankDetailsVerification = (verified, type) => {
    setEmployeeData({
      ...employeeData,
      [`is${type}VerifyStatus`]: verified ? "success" : "error",
    });
  };
  useEffect(() => {
    if (employeeData?.employeeType?.value === "Internship") {
      setEmployeeData((prevState) => ({
        ...prevState,
        user: false,
        probationPeriod: false,
      }));
    }
  }, [employeeData?.employeeType?.value]);

  const handleChange = (event) => {
    if (employeeData?.employeeType?.value === "Internship") {
      return;
    }

    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.checked,
    });
  };

  const handleactive = (event) => {
    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.checked,
    });
  };

  const onEmployeeeSubmit = async () => {
    setCirleLoading(true);
    //     const query = `
    //        mutation createUser(
    //     $firstName: String!
    //     $lastName: String!
    //     $gender: String!
    //     $salutation: String!
    //     $contactNumber: String!
    //     $dateOfBirth: String!
    //     $dateJoined: String!
    //     $emergencyNumber: String!
    //     $username: String,
    //     $grade: String!
    //     $employeeType: String!
    //     $email: String!
    //     $role: String!
    //     $empId: String!
    //     $department: String!
    //     $designation: String!
    //     $aadharnumber: String!
    //     $pan: String!
    //     $officialMail: String!
    //     $probation_period: Boolean!
    //     $fathersName: String!
    //     $address: String!
    //     $city: String!
    //     $country: String!
    //     $state: String!
    //     $zipCode: String!
    //     $maritalStatus: String!
    //     $secondaryContactNumber: String!
    //     $previousExperience: Float!
    //     $otApplicable: Boolean!
    //     $shift: String!
    //     $uanNumber: String!
    //     $memberId: String!
    //     $esicNumber: String!
    //     $accountNumber: String!
    //     $bankName: String!
    //     $ifscNumber: String!
    //     $branchName: String!
    //     $teamleader: String!
    //     $cifNumber: String!
    // ) {
    //     createUser(input: {
    //         firstName: $firstName
    //         lastName: $lastName
    //         gender: $gender
    //          username: $username,
    //         salutation: $salutation
    //         contactNumber: $contactNumber
    //         dateOfBirth: $dateOfBirth
    //         dateOfJoining: $dateJoined
    //         emergencyContact: $emergencyNumber
    //         grade: $grade
    //         employeeType: $employeeType
    //         email: $email
    //         aadharNumber: $aadharnumber
    //         panNumber: $pan
    //         empid: $empId
    //         department: $department
    //         designation: $designation
    //         fathersName: $fathersName
    //         role: $role
    //         probationPeriod: $probation_period
    //         address: $address
    //         city: $city
    //         country: $country
    //         state: $state
    //         zipCode: $zipCode
    //         maritalStatus: $maritalStatus
    //         previousExperience: $previousExperience
    //             $attendanceId: String!
    //         secondaryContactNumber: $secondaryContactNumber
    //         otApplicable: $otApplicable
    //         shift: $shift
    //         uanNumber: $uanNumber
    //         memberId: $memberId
    //         esicNumber: $esicNumber
    //         officialMail: $officialMail
    //         teamleader:$teamleader
    //         bankDetails: {
    //             accountNumber: $accountNumber
    //             bankName: $bankName
    //             ifscNumber: $ifscNumber
    //             branchName: $branchName
    //             cifNumber: $cifNumber
    //         }
    //     }) {
    //         users {
    //             id
    //             email
    //         }
    //         error
    //         success
    //         message
    //     }
    // }
    //  `;

    const query = `
       mutation CreateUser($input: UsersDetailsInput!) {  
 
  createUser(input: $input) {  
 
    message  
 
    success  
 
    error  
 
    users {  
 
      id  
 
      email  
 
      empid  
 
      firstName  
 
      lastName  
 
      username  
 
      taxSlab
 
    }  
 
  }  
 
} 
 `;

    let aadharnumberr = employeeData.aadharnumber.replace(/\s+/g, "");

    try {
      const response = await axios({
        url: BASEURL, // replace with your actual URL
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              firstName: employeeData.firstName,
              lastName: employeeData.lastName,
              gender: employeeData.gender?.label || "",
              salutation: employeeData.salutation || "",
              contactNumber: employeeData.contactNumber,
              dateOfBirth: employeeData.dob,
              dateOfJoining: employeeData.joiningDate,
              emergencyContact: employeeData.emergencyNumber || Mobilecode,
              username: employeeData.userName,
              grade: "A",
              employeeType: employeeData.employeeType?.value || "",
              email: employeeData.officialmailid,
              role: employeeData.role?.roleid || "",
              empid: employeeData.employeeId,
              department: employeeData.department?.value || "",
              designation: employeeData.designation?.value || "",
              aadharNumber: aadharnumberr,
              panNumber: employeeData.pannumber,
              officialMail: employeeData.email,
              probationPeriod: employeeData.probationPeriod,
              fathersName: employeeData.fathername,
              address: employeeData.address,
              city: employeeData.city?.value || "",
              country: employeeData.country?.value || "",
              state: employeeData.state?.value || "",
              zipCode: employeeData.zipcode,
              maritalStatus: employeeData.martialstatus?.value || "",
              secondaryContactNumber: employeeData.emergencyNumber,
              previousExperience: employeeData.previousExperience,
              attendanceId: employeeData.attendanceId,
              otApplicable: employeeData.user,
              shift: employeeData.shifts?.label || "",
              uanNumber: employeeData.uannumber,
              memberId: employeeData.memberid,
              esicNumber: employeeData.esicnumber,
              teamleader:
                employeeData.reportingManager?.id ||
                employeeData.reportingManager ||
                "",
              taxSlab: employeeData.taxRegime?.value || "",
              bankDetails: [
                {
                  accountNumber: employeeData.accountnumber,
                  bankName: employeeData.bankname,
                  ifscNumber: employeeData.enterIfsc,
                  branchName: employeeData.branchname,
                  cifNumber: employeeData.cifnumber,
                },
              ],
            },
          },
        }),
      });

      if (response.data.data.createUser.error == true) {
        let val = response.data.data.createUser.message;

        if (val == "Official Mail must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Email is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else if (val == "Aadhar number must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Aadhar number is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else if (val == "PAN number must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "PAN number is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else if (val == "Employee ID must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Employee ID is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else if (val == "Email must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Official Mail ID is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else if (val == "Contact Number must be unique.") {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Contact Number is already Exit!",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //     ...snackBar,
      //     Success: true
      // })
      if (response.data.data.createUser.success == true) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      }
      setCirleLoading(false);
      // setCirleLoading(false)
      // navigate("/employee-management");
    } catch (error) {
      console.error("responseError:", error.message);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      // setCirleLoading(false)
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      employeeData.firstNameStatus === "success" &&
      employeeData.lastNameStatus === "success" &&
      employeeData.dobStatus === "success" &&
      employeeData.emailStatus === "success" &&
      employeeData.genderStatus === "success" &&
      employeeData.martialstatusStatus === "success" &&
      employeeData.addressStatus === "success" &&
      employeeData.countryStatus === "success" &&
      employeeData.stateStatus === "success" &&
      employeeData.cityStatus === "success" &&
      employeeData.zipcodeStatus === "success" &&
      employeeData.aadharnumberStatus === "success" &&
      employeeData.pannumberStatus === "success" &&
      employeeData.employeeIdStatus === "success" &&
      employeeData.joiningDateStatus === "success" &&
      employeeData.departmentStatus === "success" &&
      employeeData.designationStatus === "success" &&
      // employeeData.shiftsStatus === "success" &&
      employeeData.officialmailidStatus === "success" &&
      employeeData.employeeTypeStatus === "success" &&
      employeeData.roleStatus === "success" &&
      employeeData.previousExperienceStatus === "success" &&
      employeeData.taxRegimeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const checkAllBankFields = () => {
    let allowSubmit = false;
    if (
      employeeData.accountnumberStatus === "success" &&
      employeeData.banknameStatus === "success" &&
      employeeData.enterIfscStatus === "success" &&
      employeeData.branchnameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddEmployee = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onEmployeeeSubmit();

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  // Function to move the previous step
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const processJoiningDate = (joiningDate) => {
    if (!joiningDate) {
      console.error("No joining date provided.");
      return null;
    }

    // Ensure the date is valid
    const date = new Date(joiningDate);
    if (isNaN(date)) {
      console.error("Invalid date format:", joiningDate);
      return null;
    }

    // Extract the date in YYYY-MM-DD format
    const formattedDate = date.toISOString().split("T")[0]; // Get the part before the 'T'

    return formattedDate;
  };
  // Utility function to format aadhar number
  const formatAadharNumber = (aadhar) => {
    return aadhar ? aadhar.replace(/(\d{4})(\d{4})(\d{4})/, "$1 $2 $3") : "";
  };

  const [Active, setActive] = useState(false);
  const [report, setreport] = useState("");
  const getemployeedata = async (id) => {
    const query = `query getUserDetail($id: String!) {
  userDetail(Id: $id) {
    id
    lastLogin
    username
    firstName
    lastName
    isActive
    dateJoined
     dateOfJoining
    email
    salutation
    dateOfBirth
    contactNumber
    emergencyContact
    gender
    employeeType
    lastUpdate
    department
    designation
    empid
    grade
    probationPeriod
    aadharNumber
    panNumber
    password
    LastWorkingDay
    secondaryContactNumber
    role{
      id
      description
      role
    }
    officialMail
    address
    teamleader
    city
    country
    zipCode
    state
    maritalStatus
    previousExperience
     attendanceId
    otApplicable
    shift
    uanNumber
    memberId
    esicNumber
    fathersName
    taxSlab
    bankDetails {
      bankName
      accountNumber
      branchName
      ifscNumber
      cifNumber
    }
  }
}
`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      let result = response.data.data.userDetail;

      setallfecthdata([result]);

      const departmentoption = department.find(
        (d) => d.departmentName == result.department,
      );

      const designationoption = designation.find(
        (d) => d.designation == result.designation,
      );
      let repotingmanageronoption = reportManager?.find(
        (d) => d.user?.id == result?.teamleader,
      );
      setreport(repotingmanageronoption);

      const shitoption = shiftdata.find((s) => s.name == result.shift);
      const employeedata = typedata.find((s) => s.value == result.employeeType);

      setTogglePage({
        ...togglePage,
        view: true,
      });

      setEmployeeData({
        firstName: result?.firstName || "",
        firstNameStatus: result.firstName ? "success" : "unchecked",
        lastName: result?.lastName || "",
        lastNameStatus: result?.lastName ? "success" : "unchecked",
        activeuser: result?.isActive || "",
        fathername: result?.fathersName || "",
        fathernameStatus: result?.fathersName ? "success" : "unchecked",
        dob: result?.dateOfBirth || "",
        dobStatus: result?.dateOfBirth ? "success" : "unchecked",
        userName: result?.username || "",
        activeuser: result?.isActive || false,
        lastworking: result?.LastWorkingDay || null,
        email: result?.officialMail || "",
        emailStatus: result?.officialMail ? "success" : "unchecked" || "",
        gender:
          resources?.gender?.find((g) => g.value === result.gender) || null,

        genderStatus: resources?.gender?.find((g) => g.value === result.gender)
          ? "success"
          : "unchecked",
        martialstatus:
          resources.martialstatus?.find(
            (m) => m?.value === result?.maritalStatus,
          ) || null,
        martialstatusStatus: resources?.martialstatus?.find(
          (m) => m?.value === result?.maritalStatus,
        )
          ? "success"
          : "unchecked",
        address: result?.address || "",
        addressStatus: result?.address ? "success" : "unchecked",
        country: { value: result?.country, label: result?.country } || "",
        countryStatus: result?.country ? "success" : "unchecked",
        state: { value: result?.state, label: result?.state } || "",
        stateStatus: result?.state ? "success" : "unchecked",
        city: { value: result?.city, label: result?.city } || "",
        cityStatus: result?.city ? "success" : "unchecked",
        zipcode: result?.zipCode || "",
        zipcodeStatus: result?.zipCode ? "success" : "unchecked",

        aadharnumber: formatAadharNumber(result?.aadharNumber) || "",
        aadharnumberStatus: result?.aadharNumber ? "success" : "unchecked",
        pannumber: result?.panNumber || "",
        pannumberStatus: result?.panNumber ? "success" : "unchecked",
        employeeId: result?.empid || "",
        employeeIdStatus: result?.empid ? "success" : "unchecked",
        joiningDateStatus: result?.dateJoined ? "success" : "unchecked",
        role: { value: result?.role?.id, label: result?.role?.role } || "",
        roleStatus: result?.role?.id ? "success" : "unchecked",
        joiningDate: processJoiningDate(result?.dateOfJoining) || "",
        department: departmentoption
          ? {
              value: departmentoption?.departmentName,
              label: departmentoption?.departmentName,
            }
          : null,

        departmentStatus: departmentoption?.departmentName
          ? "success"
          : "unchecked",
        reportingManager: repotingmanageronoption
          ? {
              value: repotingmanageronoption?.user?.id,
              label: repotingmanageronoption?.user?.firstName,
              id: repotingmanageronoption?.user?.id,
            }
          : null,
        reportingManagerStatus: repotingmanageronoption?.user.id
          ? "success"
          : "unchecked",
        designation: designationoption
          ? {
              value: designationoption?.designation,
              label: designationoption?.designation,
            }
          : null,
        designationStatus: designationoption?.designation
          ? "success"
          : "unchecked",
        employeeType: employeedata
          ? {
              value: employeedata?.value,
              label: employeedata?.value,
            }
          : null,

        employeeTypeStatus: employeedata?.value ? "success" : "unchecked",
        officialmailid: result?.email || "",
        officialmailidStatus: result?.email ? "success" : "unchecked",
        shifts: { value: result?.shift, label: result?.shift } || "",

        shiftsStatus: result?.shift ? "success" : "unchecked",
        previousExperience:
          Number(parseFloat(result?.previousExperience).toFixed(1)) || "0",

        previousExperienceStatus: result?.previousExperience
          ? "success"
          : "unchecked",
        attendanceId: result?.attendanceId,
        attendanceIdStatus: result?.attendanceId ? "success" : "unchecked",
        probationPeriod: result?.probationPeriod || "",
        user:
          result.employeeType == "Employee"
            ? result?.otApplicable
              ? true
              : false
            : false || "",
        accountnumber: result?.bankDetails?.accountNumber,

        accountnumberStatus: result?.bankDetails?.accountNumber
          ? "success"
          : "unchecked",

        bankname: result.bankDetails?.bankName,

        banknameStatus: result?.bankDetails?.bankName ? "success" : "unchecked",
        enterIfsc: result?.bankDetails?.ifscNumber,

        enterIfscStatus: result?.bankDetails?.ifscNumber
          ? "success"
          : "unchecked",
        cifnumber: result?.bankDetails?.cifNumber,
        cifnumberStatus: result?.bankDetails?.cifNumber
          ? "success"
          : "unchecked",
        branchname: result?.bankDetails?.branchName,

        branchnameStatus: result?.bankDetails?.branchName
          ? "success"
          : "unchecked",
        uannumber: result?.uanNumber || "",
        uannumberStatus: result?.uanNumber ? "success" : "unchecked",
        memberid: result?.memberId || "",
        memberidStatus: result?.memberId ? "success" : "unchecked",
        esicnumber: result?.esicNumber || "",
        esicnumberStatus: result?.esicNumber ? "success" : "unchecked",
        taxRegime: {
          label: result.taxSlab,
          value: result.taxSlab,
        },
        taxRegimeStatus: result?.taxSlab ? "success" : "unchecked",
      });

      setTimeout(() => {
        setEmployeeData((prevFeedback) => ({
          ...prevFeedback,
          contactNumber: result?.contactNumber,
          contactNumberStatus: result?.contactNumber ? "success" : "unchecked",
          emergencyNumber: result?.emergencyContact,
        }));
      }, 500);

      setOriginalWeekoffData({
        firstName: result?.firstName,
        lastName: result?.lastName,
        fathername: result?.fathersName,
        dob: result?.dateOfBirth,
        email: result?.email,
        gender: resources.gender.find((g) => g.value === result.gender) || null,
        martialstatus:
          resources.martialstatus.find(
            (m) => m.value === result.maritalStatus,
          ) || null,
        address: result.address,
        // country: countryOption
        //   ? { value: countryOption.name, label: countryOption.name }
        //   : null,
        country: { value: result?.country, label: result?.country },
        // state: stateoption
        //   ? { value: stateoption.name, label: stateoption.name }
        //   : null,
        state: { value: result?.state, label: result?.state },
        // city: cityoption
        //   ? { value: cityoption.name, label: cityoption.name }
        //   : null,
        city: { value: result?.city, label: result?.city },
        zipcode: result.zipCode,
        contactNumber: result.contactNumber,
        emergencyNumber: result.emergencyContact,
        aadharnumber: result.aadharNumber,
        pannumber: result.panNumber,
        employeeId: result.empid,
        joiningDate: result.dateOfJoining,
        reportingManager: {
          value: result.reportingManager,
          label: result.reportingManager,
        },
        department: departmentoption
          ? {
              value: departmentoption.departmentName,
              label: departmentoption.departmentName,
            }
          : null,
        designation: designationoption
          ? {
              value: designationoption.designation,
              label: designationoption.designation,
            }
          : null,
        officialmailid: result.officialMail,
        shifts: { value: result?.shift, label: result?.shift },
        previousExperience: result.previousExperience,
        probationPeriod: result.probationPeriod,
        user: result.otApplicable,
        accountnumber: result?.bankDetails?.accountNumber,

        bankname: result?.bankDetails?.bankName,
        enterIfsc: result?.bankDetails?.ifscNumber,
        cifnumber: result?.bankDetails?.cifNumber,
        branchname: result?.bankDetails?.branchName,
        uannumber: result.uanNumber,
        memberid: result.memberId,
        esicnumber: result.esicNumber,
      });
      setActive(result?.isActive);
    } catch (error) {
      console.error("ReponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const Updateempolyeedetails = async () => {
    setCirleLoading(true);
    //     const query = `mutation updateUser(
    //   $id: String!,
    //   $firstName: String,
    //   $lastName: String,
    //   $gender: String,
    //   $salutation: String,
    //   $contactNumber: String,
    //   $dateOfBirth: String,
    //   $dateJoined: String,
    //   $isActive: Boolean,
    //   $emergencyContact: String,
    //   $fathersName: String,
    //   $grade: String,
    //   $employeeType: String,
    //   $email: String,
    //   $empId: String,
    //   $department: String,
    //   $designation: String,
    //   $teamleader: String,
    //   $status: Boolean,
    //   $maritalStatus: String,
    //   $probationPeriod: Boolean,
    //   $previousExperience: Decimal,
    //    $attendanceId: String!
    //   $address: String,
    //   $country: String,
    //   $state: String,
    //   $city: String,
    //   $zipCode: String,
    //   $role: String,
    //   $otApplicable: Boolean,
    //   $shift: String,
    //   $officialMail: String,
    //   $aadharNumber: String,
    //   $panNumber: String,
    //   $uanNumber: String,
    //   $memberId: String,
    //   $esicNumber: String,
    //   $secondaryContactNumber: String,
    //   $bankDetails: [BankDetailsInput]
    // ) {
    //   updateUser(input: {
    //     id: $id,
    //     firstName: $firstName,
    //     lastName: $lastName,
    //     gender: $gender,
    //     salutation: $salutation,
    //     contactNumber: $contactNumber,
    //     dateOfBirth: $dateOfBirth,
    //     dateJoined: $dateJoined,
    //     emergencyContact: $emergencyContact,
    //     fathersName:$fathersName,
    //     grade: $grade,
    //     employeeType: $employeeType,
    //     probationPeriod: $probationPeriod,
    //     email: $email,
    //     isActive:$isActive,
    //     empid: $empId,
    //     department: $department,
    //     designation: $designation,
    //     teamleader: $teamleader,
    //     maritalStatus: $maritalStatus,
    //     previousExperience: $previousExperience,
    //     address: $address,
    //     country: $country,
    //     state: $state,
    //     city: $city,
    //     zipCode: $zipCode,
    //     role: $role,
    //     otApplicable: $otApplicable,
    //     shift: $shift,
    //     officialMail: $officialMail,
    //     aadharNumber: $aadharNumber,
    //     panNumber: $panNumber,
    //     uanNumber: $uanNumber,
    //     memberId: $memberId,
    //     esicNumber: $esicNumber,
    //     status: $status
    //     secondaryContactNumber: $secondaryContactNumber
    //     bankDetails: $bankDetails
    //   }) {
    //     users {
    //       id
    //       firstName
    //       lastName
    //       email
    //       contactNumber
    //       department
    //       designation
    //       probationPeriod
    //       gender
    //       grade
    //       employeeType
    //       role{
    //         id
    //         role
    //       }
    //       fathersName
    //       probationPeriod
    //       empid
    //       secondaryContactNumber
    //       otApplicable
    //       shift
    //       officialMail
    //       salutation
    //       dateJoined
    //       dateOfBirth
    //       emergencyContact
    //       maritalStatus
    //       previousExperience
    //       address
    //       isActive
    //       city
    //       country
    //       zipCode
    //       aadharNumber
    //       panNumber
    //       uanNumber
    //       memberId
    //       esicNumber
    //       bankDetails{
    //         accountNumber
    //         bankName
    //         ifscNumber
    //         branchName
    //         cifNumber
    //       }
    //     }
    //           message
    //     success
    //     error
    //   }
    // }`;

    const query = `
mutation UpdateUser($input: UsersDetailsUpdateInput!) { 
  updateUser(input: $input) { 
    success 
    error 
    message 
    users { 
      id 
      firstName 
      lastName 
      email 
      empid 
      taxSlab 
    } 
  } 
} `;

    let rolevalue = roledata.filter(
      (val) => val.role == employeeData.role.label,
    );

    let aadharnumberr = employeeData.aadharnumber.replace(/\s+/g, "");

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          // variables:{ input:{
          //   id: id,
          //   salutation: "Mr",
          //   firstName: employeeData.firstName,
          //   isActive: employeeData.activeuser,
          //   lastName: employeeData.lastName,
          //   fathersName: employeeData.fathername,

          //   dateOfBirth: employeeData.dob,
          //   email: employeeData.officialmailid,
          //   gender: employeeData.gender?.label,
          //   maritalStatus: employeeData.martialstatus?.value,
          //   address: employeeData.address,
          //   country: employeeData.country?.value,
          //   state: employeeData.state?.value,
          //   city: employeeData.city?.value,
          //   zipCode: employeeData.zipcode,
          //   contactNumber: employeeData.contactNumber,
          //   emergencyContact: employeeData.emergencyNumber,
          //   secondaryContactNumber: employeeData.emergencyNumber,
          //   aadharNumber: aadharnumberr,
          //   panNumber: employeeData.pannumber,
          //   empId: employeeData.employeeId,
          //   dateJoined: employeeData.joiningDate,
          //   grade: "A",
          //   role: rolevalue[0]?.id,
          //   employeeType: employeeData.employeeType?.value,
          //   department: employeeData.department?.value,
          //   designation: employeeData.designation?.value,
          //   shift: employeeData.shifts?.label || "",
          //   officialMail: employeeData.email,
          //   previousExperience: employeeData.previousExperience,
          //   probationPeriod: employeeData.probationPeriod,
          //   otApplicable: employeeData.user,
          //   uanNumber: employeeData.uannumber,
          //   memberId: employeeData.memberid,
          //   esicNumber: employeeData.esicnumber,
          //   taxSlab: employeeData.taxRegime?.value || "Old Tax Regime",
          //   teamleader: employeeData.reportingManager?.id || "",
          //   status: true,
          //   bankDetails: [
          //     {
          //       accountNumber: employeeData?.accountnumber
          //         ? employeeData?.accountnumber
          //         : "",
          //       bankName: employeeData?.bankname ? employeeData?.bankname : "",
          //       ifscNumber: employeeData?.enterIfsc
          //         ? employeeData?.enterIfsc
          //         : "",
          //       cifNumber: employeeData?.cifnumber
          //         ? employeeData?.cifnumber
          //         : "",
          //       branchName: employeeData?.branchname
          //         ? employeeData?.branchname
          //         : "",
          //     },
          //   ],
          // }},
          variables: {
            input: {
              id: id,
              salutation: "Mr",
              firstName: employeeData.firstName,
              isActive: employeeData.activeuser,
              LastWorkingDay: employeeData.activeuser
                ? null
                : employeeData?.lastworking,
              lastName: employeeData.lastName,
              fathersName: employeeData.fathername,
              dateOfBirth: employeeData.dob,
              email: employeeData.officialmailid,
              gender: employeeData.gender?.label,
              maritalStatus: employeeData.martialstatus?.value,
              address: employeeData.address,
              country: employeeData.country?.value,
              state: employeeData.state?.value,
              city: employeeData.city?.value,
              zipCode: employeeData.zipcode,
              contactNumber: employeeData.contactNumber,
              emergencyContact: employeeData.emergencyNumber,
              secondaryContactNumber: employeeData.emergencyNumber,
              aadharNumber: aadharnumberr,
              panNumber: employeeData.pannumber,
              empid: employeeData.employeeId,
              dateJoined: employeeData.joiningDate,
              dateOfJoining: employeeData.joiningDate,
              grade: "A",
              role: rolevalue[0]?.id,
              employeeType: employeeData.employeeType?.value,
              department: employeeData.department?.value,
              designation: employeeData.designation?.value,
              shift: employeeData.shifts?.label || "",
              officialMail: employeeData.email,
              previousExperience: employeeData.previousExperience,
              attendanceId: employeeData.attendanceId,
              probationPeriod: employeeData.probationPeriod,
              otApplicable: employeeData.user,
              uanNumber: employeeData.uannumber,
              memberId: employeeData.memberid,
              esicNumber: employeeData.esicnumber,
              taxSlab: employeeData?.taxRegime?.value || "",
              teamleader: employeeData.reportingManager?.id || "",
              status: true,
              bankDetails: [
                {
                  accountNumber: employeeData?.accountnumber || "",
                  bankName: employeeData?.bankname || "",
                  ifscNumber: employeeData?.enterIfsc || "",
                  cifNumber: employeeData?.cifnumber || "",
                  branchName: employeeData?.branchname || "",
                },
              ],
            },
          },
        }),
      });

      if (response.data.data.updateUser?.error == true) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.data.updateUser?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }

      if (response.data.data.updateUser?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      }
      setCirleLoading(false);
    } catch (error) {
      console.error("Errorresponse:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDepartment();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardDepartment = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setEmployeeData({
      salutation: "Mr",
      firstName: originalWeekoffData.firstName,
      lastName: originalWeekoffData.lastName,
      fathername: originalWeekoffData.fathername,
      dob: originalWeekoffData.dob,
      email: originalWeekoffData.email,
      gender: {
        value: originalWeekoffData.gender.label,
        label: originalWeekoffData.gender.label,
      },
      martialstatus: {
        value: originalWeekoffData.martialstatus.value,
        label: originalWeekoffData.martialstatus.value,
      },
      address: originalWeekoffData.address,
      country: {
        value: originalWeekoffData.country.value,
        label: originalWeekoffData.country.value,
      },
      state: {
        value: originalWeekoffData.state.value,
        label: originalWeekoffData.state.value,
      },
      city: {
        value: originalWeekoffData.city.value,
        label: originalWeekoffData.city.value,
      },
      zipcode: originalWeekoffData.zipcode,
      contactNumber: originalWeekoffData.contactNumber,
      emergencyNumber: originalWeekoffData.emergencyNumber,
      secondaryContactNumber: originalWeekoffData.emergencyNumber,
      aadharnumber: originalWeekoffData.aadharnumber,
      pannumber: originalWeekoffData.pannumber,
      employeeId: originalWeekoffData.employeeId,
      joiningDate: originalWeekoffData.dateOfJoining,
      grade: "A",
      role: originalWeekoffData.designation?.value,
      employeeType: "type",
      department: {
        value: originalWeekoffData.department.value,
        label: originalWeekoffData.department.value,
      },
      designation: {
        value: originalWeekoffData.designation.value,
        label: originalWeekoffData.designation.value,
      },
      shifts: {
        value: originalWeekoffData.shifts.value,
        label: originalWeekoffData.shifts.value,
      },
      officialmailid: originalWeekoffData.officialmailid,
      previousExperience: originalWeekoffData.previousExperience,
      probationPeriod: originalWeekoffData.probationPeriod,
      username: originalWeekoffData.userName,
      user: originalWeekoffData.user,
      accountnumber: originalWeekoffData.accountnumber,
      bankname: originalWeekoffData.bankname,
      enterIfsc: originalWeekoffData.enterIfsc,
      cifnumber: originalWeekoffData.cifnumber,
      branchname: originalWeekoffData.branchname,
      uannumber: originalWeekoffData.uannumber,
      memberid: originalWeekoffData.memberid,
      esicnumber: originalWeekoffData.esicnumber,
      teamleader: originalWeekoffData.reportingManager,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteemployee();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const ondeleteemployee = async () => {
    const query = `
    mutation DeleteUser($id: String!) { 
  deleteUsers(id: $id) { 
    deleteusers 
  } 
}
    `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: { id: id },
      });

      let data = response.data.data.deleteUsers;

      if (data) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={9} sm={9}>
              <Card>
                <CardHeader
                  title={
                    <>
                      {togglePage.view === true || togglePage.edit === true ? (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              {togglePage.view
                                ? "View Employee Details"
                                : "Edit Employee Details"}
                            </MaterialTypography>
                          </Stack>
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "EditEmployee" &&
                                item.can_access,
                            ) &&
                            pageState.state !== "submitting" && (
                              <ButtonGroup
                                variant="outlined"
                                aria-label="Loading button group"
                              >
                                <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  onClick={toggleEdit}
                                  startIcon={<EditIcon />}
                                >
                                  Edit
                                </MaterialButton>
                                <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  onClick={AddDelete}
                                  startIcon={<DeleteIcon />}
                                >
                                  Delete
                                </MaterialButton>
                              </ButtonGroup>
                            )}
                        </Stack>
                      ) : (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Add Employee Details
                            </MaterialTypography>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  }
                />
                <CardContent sx={{ minHeight: "60vh" }}>
                  <MaterialBox>
                    <Stepper
                      activeStep={activeStep}
                      alternativeLabel
                      style={{
                        // backgroundColor: 'red',
                        padding: "0px",
                        marginTop: "40px",
                        marginBottom: "20px",
                      }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Box
                      sx={{ width: "100%", minWidth: "1000px", margin: "auto" }}
                    >
                      {activeStep === 0 && (
                        <PersonalInformation
                          employeeData={employeeData}
                          handleEmployeeDataChange={handleEmployeeDataChange}
                          resources={resources}
                          togglePage={togglePage}
                          handleEmployee={handleEmployee}
                        />
                      )}
                      {activeStep === 1 && (
                        <EmployeeInformation
                          employeeData={employeeData}
                          setEmployeeData={setEmployeeData}
                          handleEmployeeDataChange={handleEmployeeDataChange}
                          reportManager={reportManager}
                          roledata={roledata}
                          typedata={typedata}
                          department={department}
                          togglePage={togglePage}
                          Active={Active}
                          handleactive={handleactive}
                          // designation={
                          //   employeeData.department
                          //     ? designation.filter(
                          //         (val) =>
                          //           val.departmentName ==
                          //           employeeData.department.value
                          //       )
                          //     : designation
                          // }
                          designation={designation}
                          resources={resources}
                          shiftdata={shiftdata}
                          probationOptions={probationOptions}
                          handleChange={handleChange}
                        />
                      )}
                      {activeStep === 2 && (
                        <BankDetails
                          employeeData={employeeData}
                          togglePage={togglePage}
                          handleEmployeeDataChange={handleEmployeeDataChange}
                          handleBankDetailsVerification={
                            handleBankDetailsVerification
                          }
                        />
                      )}
                      {activeStep === 3 && (
                        <PFDetails
                          employeeData={employeeData}
                          togglePage={togglePage}
                          resources={resources}
                          handleEmployeeDataChange={handleEmployeeDataChange}
                          handleBankDetailsVerification={
                            handleBankDetailsVerification
                          }
                        />
                      )}
                      {activeStep === 4 && (
                        <TaxDetails
                          employeeData={employeeData}
                          togglePage={togglePage}
                          resources={resources}
                          handleEmployeeDataChange={handleEmployeeDataChange}
                          handleBankDetailsVerification={
                            handleBankDetailsVerification
                          }
                        />
                      )}
                    </Box>
                  </MaterialBox>
                </CardContent>
                <CardActions>
                  <MaterialBox
                    p={2}
                    mt={3}
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                  >
                    {activeStep === 0 ? (
                      <MaterialBox />
                    ) : (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        onClick={handleBack}
                      >
                        <NavigateBeforeIcon />
                        prev
                      </MaterialButton>
                    )}
                    {togglePage.edit && activeStep === 4 && (
                      <>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          style={{ marginLeft: "63%" }}
                          //  disabled={pageState.state === "submitting"}
                          onClick={AddDiscard}
                        >
                          Discard
                        </MaterialButton>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          // style={{ marginLeft: "44%" }}
                          //  disabled={pageState.state === "submitting"}
                          onClick={Updateempolyeedetails}
                        >
                          Update
                        </MaterialButton>
                      </>
                    )}
                    {activeStep === 4 && !EmpSubmit && (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        // onClick={handleSubmit}
                        style={{
                          maxWidth: "100px",
                          minWidth: "100px",
                          marginLeft: "65%",
                        }}
                        disabled={!checkAllFields()}
                        onClick={() => handleAddEmployee()}
                      >
                        Submit
                      </MaterialButton>
                    )}

                    {activeStep !== 4 && (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleNext}
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        // disabled={
                        //     !handleActiveStep()
                        // }
                      >
                        next
                        <NavigateNextIcon />
                      </MaterialButton>
                    )}
                  </MaterialBox>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default AddEmployee;
